// @ts-nocheck
class WImenudrawer extends HTMLElement {
  connectedCallback() {
    this.openMenuDrawer();
    this.closeMenuDrawer();
    this.closeOnBackdrop();
    this.closeOnNavLink();
  }

  openMenuDrawer() {
    document.querySelector('.WI_openMenu')?.addEventListener('click', () => {
      document.dispatchEvent(new CustomEvent('open:background', { bubbles: true }));
      document.body.style.overflow = 'hidden';
      this.style.display = 'flex';
      this.classList.add('WI_menu_visible');
      setTimeout(() => {
        this.querySelector('.WI_menuDrawer_panel')?.classList.add('WI_panel_open');
      }, 10);
    });
  }

  closeFunction() {
    const panel = this.querySelector('.WI_menuDrawer_panel');
    panel?.classList.remove('WI_panel_open');
    this.classList.remove('WI_menu_visible');
    setTimeout(() => {
      this.style.display = 'none';
      document.body.style.overflow = '';
      document.dispatchEvent(new CustomEvent('close:background', { bubbles: true }));
    }, 510);
  }

  closeMenuDrawer() {
    this.querySelector('.WI_menuDrawer_close_btn')?.addEventListener('click', () => this.closeFunction());
  }

  closeOnBackdrop() {
    this.querySelector('.WI_menuDrawer_backdrop')?.addEventListener('click', () => this.closeFunction());
  }

  // Sluit menu zodra er op een navigatielink geklikt wordt
  closeOnNavLink() {
    this.addEventListener('click', (e) => {
      const link = e.target.closest('a[href]');
      if (!link) return;
      const href = link.getAttribute('href');
      if (href && href !== '#') {
        this.closeFunction();
      }
    });
  }
}

customElements.define('wi-menudrawer', WImenudrawer);

// Inject drawer UI enhancements for cached-HTML compatibility
(function () {
  function restructureIcon(icon, labelText, addBadge) {
    if (icon.querySelector('.WI_drawer_mob_icon_circle')) return; // already restructured
    const svgs = Array.from(icon.querySelectorAll('svg'));
    const existingBadge = icon.querySelector('.WI_drawer_mob_icon_badge, .WI_zichtBubble');

    // Build inner circle span
    const circle = document.createElement('span');
    circle.className = 'WI_drawer_mob_icon_circle';
    svgs.forEach(function (svg) { circle.appendChild(svg); });
    if (addBadge) {
      if (existingBadge) {
        circle.appendChild(existingBadge);
      } else {
        const badge = document.createElement('div');
        badge.className = 'WI_drawer_mob_icon_badge WI_zichtBubble';
        badge.setAttribute('data-wi-zicht-count', '');
        circle.appendChild(badge);
      }
    }

    // Rebuild icon: circle + label below
    icon.innerHTML = '';
    icon.appendChild(circle);
    const label = document.createElement('span');
    label.className = 'WI_drawer_mob_icon_label';
    label.textContent = labelText;
    icon.appendChild(label);
  }

  function injectDrawerUI() {
    const container = document.querySelector('.WI_drawer_mob_icons');
    if (!container) return;

    // Identify icons by href
    let zichtzendingIcon = null;
    let accountIcon = null;
    container.querySelectorAll('.WI_drawer_mob_icon').forEach(function (icon) {
      const href = icon.getAttribute('href') || '';
      if (href.includes('zichtzending')) {
        zichtzendingIcon = icon;
      } else {
        accountIcon = icon;
      }
    });

    // Restructure each icon: inner circle + label underneath
    if (accountIcon) restructureIcon(accountIcon, 'Account', false);
    if (zichtzendingIcon) restructureIcon(zichtzendingIcon, 'Zending', true);

    // Reorder: Account first, then Zending, then lang selector
    const langForm = container.querySelector('form');
    if (accountIcon && zichtzendingIcon) {
      container.innerHTML = '';
      container.appendChild(accountIcon);
      container.appendChild(zichtzendingIcon);
      if (langForm) container.appendChild(langForm);
    }

    // Add B2B button to footer if not yet present
    const footer = document.querySelector('.WI_menuDrawer_panel_footer');
    if (footer && !footer.querySelector('.WI_mob_b2b_btn')) {
      const btn = document.createElement('a');
      btn.className = 'WI_mob_b2b_btn';
      btn.href = '/pages/b2b';
      btn.innerHTML =
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/></svg>B2B Inloggen';
      footer.insertBefore(btn, footer.firstChild);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectDrawerUI);
  } else {
    injectDrawerUI();
  }
})();
